// @ts-nocheck
import { getCatalogService, GetProductCatalogsApiParameter } from "@store/Framework/Services/StoreAccountService";

import {
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = GetProductCatalogsApiParameter & HasOnSuccess<catalogApiResult> & HasOnError<string>;
type Props = {
    apiParameter: GetProductCatalogsApiParameter & { categoryName?: string; catalogName?: string };
    apiResult: catalogApiResult;
};
type HandlerType = Handler<Parameter, Props>;

export interface catalogApiResult {
    categoryName: string;
    catalogName: string;
    catalogResponse: Response | undefined;
}

export const DispatchBeginGetCatalog: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/ProductCatalogs/BeginGetCatalog",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        categoryName: props.parameter.categoryName,
        catalogName: props.parameter.catalogName,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    if (!props.apiParameter.categoryName || !props.apiParameter.catalogName) {
        return false;
    }

    try {
        const result = await getCatalogService(props.apiParameter.categoryName, props.apiParameter.catalogName);

        if (!result.successful) {
            throw new Error("File could not be loaded");
        }

        props.apiResult = {
            categoryName: props.apiParameter.categoryName,
            catalogName: props.apiParameter.catalogName,
            catalogResponse: result.result,
        };
    } catch (error) {
        props.parameter.onError?.(error as string);
        props.dispatch({
            type: "Store/Data/ProductCatalogs/CompleteGetCatalog",
            result: props.apiResult,
        });

        return false;
    }
};

export const DispatchCompleteGetCatalog: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/ProductCatalogs/CompleteGetCatalog",
        result: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult!);
};

export const chain = [
    DispatchBeginGetCatalog,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteGetCatalog,
    ExecuteOnSuccessCallback,
];

const getCatalog = createHandlerChainRunner(chain, "GetCatalog");
export default getCatalog;
